<script lang="ts">
	import IconButton from '../../basic/buttons/IconButton.svelte';
	import { contextMenuState } from '../../basic/contextmenu/ContextMenuStore';
	import { confirmState } from '../../basic/dialog/ConfirmStore';
	import type { TextBlockStore } from '../../stores/TextBlockStore.svelte';
	import type { TextBlock } from '../../types/TextBlocksTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		store: TextBlockStore;
		item: TextBlock;
		selected: boolean;
		onClick?: (e: MouseEvent) => void;
		onChildDeleted?: () => void;
	}

	let { store, item, selected, onClick, onChildDeleted }: Props = $props();

	async function openContextMenu(e: MouseEvent) {
		e.stopPropagation();
		const menuItems = [
			{
				title: $_('general.lbl_delete'),
				danger: true,
				callbackFunction: showConfirmDialog
			}
		];

		$contextMenuState = {
			x: e.clientX,
			y: e.clientY,
			menuItems: menuItems
		};
	}

	function showConfirmDialog() {
		$confirmState = {
			bodyText: $_('textblocksview.lbl_delete_text_block'),
			successCallback: deleteTextBlock,
			warningText: $_('textblocksview.lbl_security_delete')
		};
	}

	function deleteTextBlock() {
		store.handleDeleteTextBlockStore(item.id);
		onChildDeleted?.();
	}
</script>

<button
	onclick={onClick}
	class:selected
	class="bg-white dark:bg-dark-500 selected:border-secondary-200 dark:selected:border-secondary-500 border-2 border-transparent rounded p-4 relative text-left"
	oncontextmenu={(e: MouseEvent) => {
		e.preventDefault();
		openContextMenu(e);
	}}
>
	<p class="font-bold truncate">{item.shortName}</p>

	{#if selected}
		<div class="absolute bottom-2 right-2">
			<IconButton iconName="ellipsis-h" onClick={openContextMenu} showCircle={false} size="small" />
		</div>
	{/if}
</button>
